export const trackEvent = (name, properties = {}) => {
  if (!name) return
  window.heap.track(name, properties)
}
